export default __webpack_public_path__ + "338a2461078ae268ecb3632ba97e1d9e.png";